<div class="container mt-3">
  <fgbcl-marketplace-list-v2 [isList]="true" [marketplaceItemTypes]="[4]" [productsItemView]="true" />
</div>
